// @flow
import $ from "jquery";
import React from "react";
import Modal from "react-modal";
import "./ApModal.scss";

type Props = {
  isOpen: boolean,
  title: string,
  children?: React.Element<any>,
  onRequestClose: () => void
};

export default class ApModal extends React.Component {
  state: {
    modalBodyMaxHeight: number
  };
  props: Props;
  constructor(props: Props) {
    super(props);
    this.state = {
      modalBodyMaxHeight: window.innerHeight - 100
    };
  }

  componentDidMount() {
    $(window).on("resize", () => {
      this.setState({
        modalBodyMaxHeight: window.innerHeight - 100
      });
    });
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        contentLabel={this.props.title}
        className="enso-modal enso-modal__react"
        overlayClassName="enso-modal-mask"
      >
        <a className="close-btn" onClick={this.props.onRequestClose}>×</a>
        <h1>{this.props.title}</h1>
        <div
          className="modal-body modal-body__react"
          style={{ maxHeight: this.state.modalBodyMaxHeight }}
        >
          {this.props.children}
        </div>
      </Modal>
    );
  }
}

ApModal.propTypes = {
  isOpen: React.PropTypes.bool.isRequired,
  title: React.PropTypes.string.isRequired,
  onRequestClose: React.PropTypes.func
};



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/ApModal.js